import { render, staticRenderFns } from "./BookEditContributorsTab.vue?vue&type=template&id=0837d578"
import script from "./BookEditContributorsTab.vue?vue&type=script&lang=js"
export * from "./BookEditContributorsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports